import { useState, useCallback, useMemo } from "react";
import { FieldErrors } from "react-hook-form";
import { DEFAULT_VALIDATION_ERRORS } from "../constants";
import type { ValidationErrors } from "../types";

export function useValidationState() {
  const [validationErrors, setValidationErrors] = useState<ValidationErrors>(
    DEFAULT_VALIDATION_ERRORS,
  );
  const [isValidationActive, setIsValidationActive] = useState(false);

  const setTabErrors = useCallback(
    (tab: keyof ValidationErrors, hasErrors: boolean) => {
      setValidationErrors((prev) => ({ ...prev, [tab]: hasErrors }));
    },
    [],
  );

  const setFormErrorsCallback = useCallback((errors: FieldErrors) => {
    const basicInfosFields = ["provider", "priority", "merchantId"];
    const creditCardBrandsFields = ["brands"];

    const basicInfosHasErrors = basicInfosFields.some((field) => errors[field]);
    const credentialsHasErrors =
      errors.credentials !== undefined &&
      errors.credentials !== null &&
      typeof errors.credentials === "object" &&
      Object.keys(errors.credentials).length > 0;
    const creditCardBrandsHasErrors = creditCardBrandsFields.some(
      (field) => errors[field],
    );

    setValidationErrors({
      basicInfos: basicInfosHasErrors,
      credentials: credentialsHasErrors,
      creditCardBrands: creditCardBrandsHasErrors,
    });
  }, []);

  const hasAnyErrors = useMemo(
    () => Object.values(validationErrors).some(Boolean),
    [validationErrors],
  );

  const activateValidation = useCallback(() => {
    setIsValidationActive(true);
  }, []);

  const clearAllErrors = useCallback(() => {
    setValidationErrors(DEFAULT_VALIDATION_ERRORS);
  }, []);

  return {
    validationErrors,
    isValidationActive,
    setTabErrors,
    setFormErrors: setFormErrorsCallback,
    hasAnyErrors,
    activateValidation,
    clearAllErrors,
  };
}
